<template>
  <div class="p-5" style="margin:auto; text-align: center; margin-top: 200px">
      <div v-bind:style="styles" class="spinner spinner--texture"></div>
      <p class="p-3"><slot></slot>...</p>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      default: '150px'
    }
  },
  computed: {
    styles () {
      return {
        width: this.size,
        height: this.size
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .spinner {
    margin: auto;
    flex-shrink: 0;
    border: 1px #149bda solid;
    border-radius: 4px;
    position: relative;
    background: linear-gradient(45deg, transparent 49%, #149bda 50%, #149bda 50%, transparent 51%, transparent), linear-gradient(-45deg, transparent 49%, #149bda 50%, #149bda 50%, transparent 51%, transparent);
    background-size: 16px 16px;
    background-position: 0% 0%;
    animation: spTexture 1s infinite linear;
  }
  @keyframes spTexture {
    from { background-position: 0px 0px; }
    to { background-position: -16px 0px; }
  }
</style>